/* eslint-disable no-template-curly-in-string */
/* Copyright (c) 2020-present CloudIO Inc */

import { ComponentSample, Item } from 'componentregistry';

const page: {
  box: Item<'Box'>;
  box1: Item<'Box'>;
  expressionWatchListener: Item<'ExpressionWatchListener'>;
  expressionWatchListener1: Item<'ExpressionWatchListener'>;
  expressionWatcher: Item<'ExpressionWatcher'>;
  flexItem: Item<'FlexItem'>;
  flexItem1: Item<'FlexItem'>;
  flexItem2: Item<'FlexItem'>;
  flexItem3: Item<'FlexItem'>;
  flexPanel: Item<'FlexPanel'>;
  flexPanel1: Item<'FlexPanel'>;
  flexPanel2: Item<'FlexPanel'>;
  form: Item<'Form'>;
  groupATabItem: Item<'TabItem'>;
  groupBTabItem: Item<'TabItem'>;
  numberNumberField: Item<'NumberField'>;
  root: Item<'Page'>;
  setData: Item<'ActionSetData'>;
  setData1: Item<'ActionSetData'>;
  showMessage: Item<'ActionShowMessage'>;
  showMessage1: Item<'ActionShowMessage'>;
  tabPanel: Item<'TabPanel'>;
  testAliasDataStoreReference: Item<'DataStoreReference'>;
  testAliasLocalDataStore: Item<'LocalDataStore'>;
  triggerOnChange: Item<'TriggerOnChange'>;
  triggerOnChange1: Item<'TriggerOnChange'>;
  typography: Item<'Typography'>;
  typography1: Item<'Typography'>;
} = {
  box: {
    children: ['typography', 'expressionWatchListener'],
    itemId: 'box',
    parent: 'flexItem',
    props: {
      boxHeight: '1',
      boxWidth: '1',
    },
    type: 'Box',
  },
  box1: {
    children: ['typography1', 'expressionWatchListener1'],
    itemId: 'box1',
    parent: 'flexItem2',
    props: {
      boxHeight: '1',
      boxWidth: '1',
    },
    type: 'Box',
  },
  expressionWatchListener: {
    children: ['triggerOnChange'],
    itemId: 'expressionWatchListener',
    parent: 'box',
    props: {
      listenerGroupKey: 'groupA',
      watcherItemId: 'expressionWatcher',
    },
    type: 'ExpressionWatchListener',
  },
  expressionWatchListener1: {
    children: ['triggerOnChange1'],
    itemId: 'expressionWatchListener1',
    parent: 'box1',
    props: {
      listenerGroupKey: 'groupB',
      watcherItemId: 'expressionWatcher',
    },
    type: 'ExpressionWatchListener',
  },
  expressionWatcher: {
    children: [],
    itemId: 'expressionWatcher',
    parent: 'root',
    props: {
      enabledCondition: 'true',
      expressionToWatch: '$.testAlias.number',
    },
    type: 'ExpressionWatcher',
  },
  flexItem: {
    children: ['box'],
    itemId: 'flexItem',
    parent: 'flexPanel1',
    props: {},
    type: 'FlexItem',
  },
  flexItem1: {
    children: ['testAliasDataStoreReference'],
    itemId: 'flexItem1',
    parent: 'flexPanel',
    props: {
      sizeType: 'auto',
    },
    type: 'FlexItem',
  },
  flexItem2: {
    children: ['box1'],
    itemId: 'flexItem2',
    parent: 'flexPanel2',
    props: {},
    type: 'FlexItem',
  },
  flexItem3: {
    children: ['tabPanel'],
    itemId: 'flexItem3',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem3', 'flexItem1'],
    itemId: 'flexPanel',
    parent: 'root',
    props: {},
    type: 'FlexPanel',
  },
  flexPanel1: {
    children: ['flexItem'],
    itemId: 'flexPanel1',
    parent: 'groupATabItem',
    props: {},
    type: 'FlexPanel',
  },
  flexPanel2: {
    children: ['flexItem2'],
    itemId: 'flexPanel2',
    parent: 'groupBTabItem',
    props: {},
    type: 'FlexPanel',
  },
  form: {
    children: ['numberNumberField'],
    itemId: 'form',
    parent: 'testAliasDataStoreReference',
    props: {},
    type: 'Form',
  },
  groupATabItem: {
    children: ['flexPanel1'],
    itemId: 'groupATabItem',
    parent: 'tabPanel',
    props: {
      icon: {
        iconName: '',
      },
      label: {
        type: 'text',
        value: 'Group A',
      },
    },
    type: 'TabItem',
  },
  groupBTabItem: {
    children: ['flexPanel2'],
    itemId: 'groupBTabItem',
    parent: 'tabPanel',
    props: {
      icon: {
        iconName: '',
      },
      label: {
        type: 'text',
        value: 'Group B',
      },
    },
    type: 'TabItem',
  },
  numberNumberField: {
    children: [],
    itemId: 'numberNumberField',
    parent: 'form',
    props: {
      allowDecimal: false,
      flex: {
        xs: 12,
      },
      label: { type: 'text', value: 'Number' },
      sliderMin: 1,
      useSlider: true,
      viewAttribute: 'number',
    },
    type: 'NumberField',
  },
  root: {
    children: ['testAliasLocalDataStore', 'expressionWatcher', 'flexPanel'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'Watcher',
      },
    },
    type: 'Page',
  },
  setData: {
    children: [],
    itemId: 'setData',
    parent: 'triggerOnChange',
    props: {
      key: { type: 'text', value: 'groupA' },
      value: {
        type: 'expression',
        value: '`Value changed from ${$._.oldValue} to ${$._.newValue}`',
      },
    },
    type: 'ActionSetData',
  },
  setData1: {
    children: [],
    itemId: 'setData1',
    parent: 'triggerOnChange1',
    props: {
      key: { type: 'text', value: 'groupB' },
      value: {
        type: 'expression',
        value: '`Value changed from ${$._.oldValue} to ${$._.newValue}`',
      },
    },
    type: 'ActionSetData',
  },
  showMessage: {
    children: [],
    itemId: 'showMessage',
    parent: 'triggerOnChange1',
    props: {
      message: {
        type: 'text',
        value: 'Group B changed',
      },
      type: 'info',
    },
    type: 'ActionShowMessage',
  },
  showMessage1: {
    children: [],
    itemId: 'showMessage1',
    parent: 'triggerOnChange',
    props: {
      message: {
        type: 'text',
        value: 'Group A changed',
      },
      type: 'info',
    },
    type: 'ActionShowMessage',
  },
  tabPanel: {
    children: ['groupATabItem', 'groupBTabItem'],
    itemId: 'tabPanel',
    parent: 'flexItem3',
    props: {},
    type: 'TabPanel',
  },
  testAliasDataStoreReference: {
    children: ['form'],
    itemId: 'testAliasDataStoreReference',
    parent: 'flexItem1',
    props: {
      alias: 'testAlias',
    },
    type: 'DataStoreReference',
  },
  testAliasLocalDataStore: {
    children: [],
    itemId: 'testAliasLocalDataStore',
    parent: 'root',
    props: {
      alias: 'testAlias',
      dataFormat: 'json',
      dataSource: 'test',
      hideDirtyIndicator: true,
      jsonData: '[\n    {\n        "number": 50\n    }\n]',
    },
    type: 'LocalDataStore',
  },
  triggerOnChange: {
    children: ['setData', 'showMessage1'],
    itemId: 'triggerOnChange',
    parent: 'expressionWatchListener',
    props: {},
    type: 'TriggerOnChange',
  },
  triggerOnChange1: {
    children: ['setData1', 'showMessage'],
    itemId: 'triggerOnChange1',
    parent: 'expressionWatchListener1',
    props: {},
    type: 'TriggerOnChange',
  },
  typography: {
    children: [],
    itemId: 'typography',
    parent: 'box',
    props: {
      text: {
        type: 'expression',
        value: "`${$.$pageData.groupA ?? 'No change yet'}`",
      },
    },
    type: 'Typography',
  },
  typography1: {
    children: [],
    itemId: 'typography1',
    parent: 'box1',
    props: {
      text: {
        type: 'expression',
        value: "`${$.$pageData.groupB ?? 'No change yet!'}`",
      },
    },
    type: 'Typography',
  },
};

export const helpRenders: ComponentSample<'ExpressionWatcher'>[] = [
  {
    title: 'Expression Watcher',
    description: `Use the slider to change the number value and change the tabs to see the expression watcher in action.

**Steps:**

1. Change the number value from 50 to 51.
2. Notice the message "Group A changed" and the text "Value changed from 50 to 51" inside the tab Group A.
3. Change the tab to Group B.
4. Notice no change in Group B tab. (This is because the expression watch listener with key groupB just got rendered for the first time and hence no change after it's rendered.)
5. Change the number value from 51 to 52 to 53.
6. Notice the message "Group B changed (2 messages)" and the text "Value changed from 52 to 53" inside the tab Group B.
7. Change the tab to Group A.
8. Notice the message "Group A changed" and the text "Value changed from 51 to 53" inside the tab Group A (Since Group A was already rendered, but was hidden during the change from 51 to 52, the on change listener is triggered with 51 to 53).
`,
    page,
    exampleId: 'eg-01GK8P0PH39D2FDJ8HVKCD6Y07',
    clearParentChildren: false,
    height: 280,
    visibleProps: ['enabledCondition', 'expressionToWatch'],
    hideProps: true,
    item: {
      children: [],
      itemId: 'expressionWatcher',
      parent: 'root',
      props: {
        enabledCondition: 'true',
        expressionToWatch: '$.testAlias.number',
      },
      type: 'ExpressionWatcher',
    },
  },
];

export const expressionWatchListenerHelpRenders: ComponentSample<'ExpressionWatchListener'>[] =
  [
    {
      title: 'Expression Watch Listener',
      description: `Use the slider to change the number value and change the tabs to see the expression watcher listener in action.

**Steps:**

1. Change the number value from 50 to 51.
2. Notice the message "Group A changed" and the text "Value changed from 50 to 51" inside the tab Group A.
3. Change the tab to Group B.
4. Notice no change in Group B tab. (This is because the expression watch listener with key groupB just got rendered for the first time and hence no change after it's rendered.)
5. Change the number value from 51 to 52 to 53.
6. Notice the message "Group B changed (2 messages)" and the text "Value changed from 52 to 53" inside the tab Group B.
7. Change the tab to Group A.
8. Notice the message "Group A changed" and the text "Value changed from 51 to 53" inside the tab Group A (Since Group A was already rendered, but was hidden during the change from 51 to 52, the on change listener is triggered with 51 to 53).
`,
      page,
      exampleId: 'eg-01GK8Q1VK0Q3SKWSX4WCFEC1N7',
      clearParentChildren: false,
      height: 280,
      visibleProps: [],
      hideProps: true,
      item: {
        children: ['triggerOnChange'],
        itemId: 'expressionWatchListener',
        parent: 'box',
        props: {
          listenerGroupKey: 'groupA',
          watcherItemId: 'expressionWatcher',
        },
        type: 'ExpressionWatchListener',
      },
    },
  ];
